import { useFormik } from 'formik';
import React from 'react';
import AlertModal from '../AlertModal';
const initialValues = {
  countryCode: '',
  cellNumber: '',
  firstName: '',
  lastName: '',
  email: '',
  gender: null,
  age: '',
  isOpd: true,
  appliedFees: [],
  emrNo: ''
};
const AssignPaModal = ({ onSubmit, setShow, data }) => {
  const formik = useFormik({
    initialValues,
    // validationSchema: createPatientSchema,
    onSubmit: (values, { resetForm }) => {
      const servicesTaken = values?.appliedFees?.flatMap((item) =>
        Array(item?.quantity).fill(item?.serviceId)
      );
      const params = {
        ...values,
        isOpd: servicesTaken.includes(null),
        ...(data && { patientId: data?.id }),
        cellNumber: values?.cellNumber?.slice(2),
        patientName: `${values?.firstName} ${values?.lastName}`,
        countryCode: `+${values?.cellNumber?.slice(0, 2)}`,
        appliedFees: servicesTaken.filter((data) => data != null),

        gender: values?.gender?.value
      };

      delete params.firstName;
      delete params?.lastName;
      onSubmit(params, () => {
        setShow();
        resetForm();
        // { values: { ...initialValues, appliedFees: values.appliedFees } }
      });
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  return <AlertModal title={'Assign PA'}></AlertModal>;
};

export default AssignPaModal;
